import { render, staticRenderFns } from "./TabModeratorInstitutionEvent.vue?vue&type=template&id=20c37aa4&"
import script from "./TabModeratorInstitutionEvent.vue?vue&type=script&lang=js&"
export * from "./TabModeratorInstitutionEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports